<template>
  <div>
    <div class="grid justify-items-end w-5 mr-3" @click="handleClick">
      <img src="@/assets/images/home/menu.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: "menu",
  data() {
    return {
      show: false,
    };
  },
  methods: {
    handleClick() {
      this.show = !this.show;
      this.$emit("show", this.show);
    },
  },
};
</script>
<style></style>
